import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionPlantCareGoalPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-join-happy-parents')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionPlantCareGoal.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionPlantCareGoal.keepAlive'),
          value: 'keep_alive',
        },
        {
          text: t('pages.onboarding.questionPlantCareGoal.helpThrive'),
          value: 'help_thrive',
        },
        {
          text: t('pages.onboarding.questionPlantCareGoal.growCollection'),
          value: 'grow_collection',
        },
        {
          text: t('pages.onboarding.questionPlantCareGoal.becomeExpert'),
          value: 'become_expert',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
